import Vue from 'vue';
import VuePlyr from '@skjnldsv/vue-plyr'

Vue.use(VuePlyr)